import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import "./_myAccessPage.scss";
import IconChevron from './IconChevron';
import RequestDetails from "./RequestDetails/RequestDetails";
import ApplicationDetails from "./ApplicationDetails/ApplicationDetails";
import TablePaginationNew from '../../../common/Pagination/TablePaginationNew';
import Button from 'react-bootstrap/Button';
import { Form, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
// import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios';
import ActionModals from './ActionModals/ActionModals';
import { deleteRequest, setLoader, fetchAccessRequest, fetchPendingRequests, approveRequest, denyRequest, bulkApproveRequests, bulkDenyRequests, resetAction, fetchSitesForAccess } from '../../actions';
import { API_PATHS, API_BASE_PATH } from '../../actions/constant';
import { useToast } from '../../../common/base/ToastContext';
import { TEXT_PATTERN } from '../../../common/base/constants';
import { useCombined } from '../../../common/base/CombinedContext';
import RequestStatusBadge from '../../../common/base/RequestStatusBadge/RequestStatusBadge';
import { useNavigate } from 'react-router-dom';

function MyAccessPage({...props}) {
  // const dispatch = useDispatch();
  // const accessState = useSelector((state) => state.accessState);
  const DEFAULT_GATEWAY = 'Flex';
  const resolveGateway = (gateway) => (typeof gateway === 'string' && gateway.trim() ? gateway : DEFAULT_GATEWAY);
  const navigate = useNavigate();

  const [requestResponse, setRequestResponse] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [searchTxt, setSearchTxt] = useState('');
  const [approveStatus, setApproveStatus] = useState('');
  const [tableConfig, setTableConfig]= useState({
    pageSize: 5,
    totalPages: 0,
    currentPage: 1,
    pageLimit: [5, 10, 15]
  });
  const [isHashChanged, setIsHashChanged] = useState(false);
  const [hashValue, setHashValue] = useState(window.location.hash);
  const [notificationId, setNotificationId] = useState(null);
  const [sortColumn, setSortColumn] = useState(null);
  const [selectedSite, setSelectedSite] = useState('');
  const [siteOptions, setSiteOptions] = useState([]);
  const [bulkSelectedIds, setBulkSelectedIds] = useState([]);
  const [editTierData, setEditTierData] = useState({ slaTiers: [], loading: false });
  const searchTriggeredRef = useRef(false);
  const { showLoader, hideLoader } = useCombined();
  const { showToast } = useToast();
  const breadcrumbItems = [{
    title:"Cisco IT APIs",
    url:"/"
  },
  {
    title:"Request Access Management",
    url:""
  }]

  const { setBreadcrumbItems } = useCombined()
  useEffect(() => {
    setBreadcrumbItems(breadcrumbItems);
  }, [setBreadcrumbItems]);

  useEffect(() => {
    props.dispatch(fetchSitesForAccess());
  }, []);

  useEffect(() => {
    const sites = props.siteList?.data?.sites || [];
    setSiteOptions(sites);
    if (!notificationId && sites.length > 0 && !selectedSite) {
      setSelectedSite(sites[0]);
      if (siteSelectRef.current) {
        siteSelectRef.current.value = sites[0];
      }
    }
  }, [props.siteList]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const queryParams = new URLSearchParams(hash.split('?')[1]);
      const newNotifId = queryParams.get('notificationId') || null;

      if (newNotifId) {
        setSearchTxt('');
        setApproveStatus('');
        setExpandedRow(null);
        if (selectRef.current) {
          selectRef.current.value = '';
        }
      }

      setNotificationId(newNotifId);
      setIsHashChanged(true);
      setHashValue(hash);
    };

    if (window.location.hash) {
      handleHashChange();
    }
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  useEffect(() => {
    if (requestResponse.length > 0 && notificationId) {
      const index = requestResponse.findIndex(request => request.id === parseInt(notificationId));
      if (index !== -1) {
        setExpandedRow(index);
      }
    }
  }, [requestResponse, notificationId]);

  useEffect(() => {
    if (!isHashChanged) return;
    if (notificationId) {
      showLoader("fetchRequest");
      props.dispatch(fetchAccessRequest(tableConfig.currentPage, tableConfig.pageSize, '', '', notificationId, null));
    } else if (selectedSite) {
      showLoader("fetchRequest");
      props.dispatch(fetchAccessRequest(tableConfig.currentPage, tableConfig.pageSize, searchTxt, approveStatus.toUpperCase(), null, selectedSite));
    }
  }, [approveStatus, isHashChanged, selectedSite, notificationId]);

  useEffect(() => {
    let handled = false;

    if (props.errorResponse?.status == false) {
      hideLoader("failed");
      showToast({
          title: 'Operation Failed',
          bg: 'danger',
          message: props.errorResponse?.data,
      });
      handled = true;
    }

    if (props.response.data) {
      hideLoader("failed");

      if (props.response.data?.status == "SUCCESS" || props.response.data?.status == "PARTIAL") {
        const isPartial = props.response.data?.status === "PARTIAL";
        showToast({
          title: isPartial ? "Completed with errors" : "Operation Success",
          bg: isPartial ? "warning" : "success",
          message: props.response?.data?.message,
        });
        fetchRequest();
        fetchPendingRequest();
      } else {
        showToast({
          title: 'Operation Failed',
          bg: 'danger',
          message: props.response?.data?.message,
      });
      }
      handled = true;
    }

    if (handled) {
      props.dispatch(resetAction());
    }

  }, [props.errorResponse, props.response])
  
  useEffect(() => {
    if (props.accessRequestList.data) {
        setTableConfig(prev => ({
          ...prev,
          totalPages: props.accessRequestList.data.totalPages || 0
        }));
        const requests = props.accessRequestList.data.accessRequests;
        setRequestResponse(requests);
        hideLoader("fetchRequest");

        if (notificationId && requests?.length > 0) {
          const matchedReq = requests.find(r => r.id === parseInt(notificationId));
          if (matchedReq) {
            const reqSite = matchedReq.apiDetails?.domainName;
            if (reqSite && reqSite !== selectedSite) {
              setSelectedSite(reqSite);
              if (siteSelectRef.current) {
                siteSelectRef.current.value = reqSite;
              }
            }
          }
        }
    }
  }, [props.accessRequestList])

  function fetchRequest(overrides = {}) {
    const page = overrides.page ?? tableConfig.currentPage;
    const size = overrides.size ?? tableConfig.pageSize;
    showLoader("fetchRequest");
    if (notificationId) {
      props.dispatch(fetchAccessRequest(page, size, '', '', notificationId, null));
    } else {
      props.dispatch(fetchAccessRequest(page, size, searchTxt, approveStatus.toUpperCase(), null, selectedSite));
    }
  }

  async function fetchPendingRequest() {
    showLoader("fetchPendingRequest");
    props.dispatch(fetchPendingRequests());
  }

  const handleDelete = async () =>  {
    showLoader("handleDelete");
    props.dispatch(deleteRequest(selectedRequest.id, resolveGateway(selectedRequest?.gateway)));
  };

  const handleApprove = async () => {
    showLoader("handleApprove");
    props.dispatch(approveRequest(selectedRequest.id, resolveGateway(selectedRequest?.gateway), "approve", selectedRequest?.isTierChange));
  };

  const handleDeny = async (reason="") => {
    showLoader("handleDeny");
    props.dispatch(denyRequest(selectedRequest.id, resolveGateway(selectedRequest?.gateway), "reject", reason, selectedRequest?.isTierChange));
  };

  const getClassName = (status) => {
    let retClass = 'success';
    if (status.toLowerCase() === 'deny') {
      retClass = 'danger';
    }
    if (status.toLowerCase() === 'remove') {
      retClass = 'dark';
    }
    if(status.toLowerCase() === 'invalid') {
      retClass = 'info'
    }
    return `min-width-actn btn-outline-${retClass}`;
  };
  const approveBtn = {"label":"approve", "btn_variant":"btn-primary", };
  const removeBtn = {"label":"remove", "btn_variant":"btn-outline-secondary"};
  const denyBtn = {"label":"deny", "btn_variant":"btn-outline-danger",};
  const approveIco = {"label":"approve", "variant":"check-outline","tooltip_label":'Approve Request'}
  const denyIco = {"label":"deny", "tooltip_label":'Deny Request', "variant":"exit-outline"}
  const removeIco = {"label":"remove", "tooltip_label":'Remove Request', "variant":"delete"}
  const statusAction = {
    pending:[approveBtn,denyBtn],
    approved: [denyIco,removeIco],
    denied: [approveIco,removeIco],
    invalid: [removeIco]
  }

  const fetchSlaTiers = async (requestId, gatewayName) => {
    setEditTierData({ slaTiers: [], loading: true });
    try {
      const request = requestResponse.find(r => r.id === requestId);
      const apiDetails = request?.apiDetails;
      if (!apiDetails?.organizationId || !apiDetails?.assetId || !apiDetails?.versionGroup || !apiDetails?.apiInstanceId) {
        setEditTierData({ slaTiers: [], loading: false });
        showToast({ title: 'Error', bg: 'danger', message: 'Missing API details to fetch SLA tiers' });
        return;
      }
      const res = await axios.get(
        `${API_BASE_PATH}/organizations/${apiDetails.organizationId}/assets/${apiDetails.assetId}/versionGroups/${apiDetails.versionGroup}/instances/${apiDetails.apiInstanceId}/tiers?gateway=${gatewayName}`
      );
      setEditTierData({ slaTiers: res.data || [], loading: false });
    } catch (err) {
      setEditTierData({ slaTiers: [], loading: false });
      showToast({ title: 'Error', bg: 'danger', message: 'Failed to load SLA tiers' });
    }
  };

  const clickPop = (type, id, gateway, isTierChange) => {
    setSelectedRequest({"type":type, "id":id, "gateway": resolveGateway(gateway), "isTierChange": isTierChange});
    setIsModalOpen(true);
    if (type === 'editTier') {
      fetchSlaTiers(id, resolveGateway(gateway));
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRequest(null);
  };
 
  const handleViewAll = () => {
    setNotificationId(null);
    setExpandedRow(null);
    setApproveStatus('');
    if (selectRef.current) {
      selectRef.current.value = '';
    }
    // Keep the notification request's site selected so "View all" shows every
    // request for that site; fall back to the first available site.
    const targetSite = selectedSite || siteOptions[0] || '';
    setSelectedSite(targetSite);
    if (siteSelectRef.current) {
      siteSelectRef.current.value = targetSite;
    }
    window.location.hash = '#request/';
  };

  const getActionBtns = (status, req_id, gateway) => {
     let statusCase = status.toLowerCase();
     let retVal = "";
     switch (statusCase) {
      case 'pending':
           retVal = statusAction[statusCase].map(action => (
            <button
              key={action.label}
              className={`btn text-capitalize iap-btn ${action.btn_variant}`}
              onClick={() => clickPop(action.label, req_id, gateway)}
            >
              {action.label}
            </button>
          ))
        break;

       default:
        retVal =  (
        <div className='d-flex align-items-center '> 
        {statusAction[statusCase].map(action => (
             <hbr-tooltip key={action.label} size="large" content={action.tooltip_label} placement="top" class="atm-tooltip--large">
               <i class={`atm-icon me-3 ${action.variant}`} onClick={() => clickPop(action.label, req_id, gateway)}/>
             </hbr-tooltip>
        ))}</div>)
       break;
     }
      return (
        <div className="action">
              {retVal}
         </div>
     )
  }

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
    setBulkSelectedIds([]);
  };

  const handleBulkApprove = () => {
    if (bulkSelectedIds.length === 0) return;
    setSelectedRequest({ type: 'bulkApprove', ids: bulkSelectedIds });
    setIsModalOpen(true);
  };

  const handleBulkDeny = () => {
    if (bulkSelectedIds.length === 0) return;
    setSelectedRequest({ type: 'bulkDeny', ids: bulkSelectedIds });
    setIsModalOpen(true);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
     handleSearch();
    }
  };
  const handleEditTier = async (data) => {
    showLoader("editTier");
    try {
      const res = await axios.patch(`${API_PATHS.ACCESS_PAGE_API}/${selectedRequest.id}/editTier`, {
        newSlaTierId: data.newSlaTierId,
        reason: data.reason
      });
      const responseMessage = res.data?.message || 'SLA tier updated successfully';
      showToast({ title: 'Operation Success', bg: 'success', message: responseMessage });
      fetchRequest();
      fetchPendingRequest();
    } catch (err) {
      showToast({ title: 'Operation Failed', bg: 'danger', message: err.response?.data?.error || 'Failed to update SLA tier' });
    } finally {
      hideLoader("editTier");
    }
  };

  const handleRequest = (reason = "") => {
    closeModal();
    if (selectedRequest.type === 'editTier') {
      handleEditTier(reason);
    } else if (selectedRequest.type === 'bulkApprove') {
      showLoader("bulkApprove");
      const bulkGateway = resolveGateway(
        requestResponse.find((r) => selectedRequest.ids?.includes(r.id))?.gateway
      );
      props.dispatch(bulkApproveRequests(selectedRequest.ids, bulkGateway));
      setBulkSelectedIds([]);
    } else if (selectedRequest.type === 'bulkDeny') {
      showLoader("bulkDeny");
      const bulkGateway = resolveGateway(
        requestResponse.find((r) => selectedRequest.ids?.includes(r.id))?.gateway
      );
      props.dispatch(bulkDenyRequests(selectedRequest.ids, reason, bulkGateway));
      setBulkSelectedIds([]);
    } else if (selectedRequest.type === 'remove') {
      handleDelete();
    } else if (selectedRequest.type === 'approve') {
      handleApprove()
    } else {
      handleDeny(reason);
    }
  }
  const handleSearch = () => {
    setTableConfig(prev => ({ ...prev, currentPage: 1 }));
    searchTriggeredRef.current = true;
    if (notificationId) {
      setNotificationId(null);
      window.location.hash = '#request/';
    }
    fetchRequest({ page: 1 });
  };

  const handleSearchTermChange = (e) => {
    const { value } = e.target;
    if (TEXT_PATTERN.test(value) || value === '') {
      setSearchTxt(value);
    }
  };

  const handlePageChange = (pageNumber) => {
    setTableConfig(prev => ({ ...prev, currentPage: pageNumber }));
    setExpandedRow(null);
    setBulkSelectedIds([]);
    fetchRequest({ page: pageNumber });
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setTableConfig(prev => ({ ...prev, currentPage: 1, pageSize: newRowsPerPage }));
    setExpandedRow(null);
    setBulkSelectedIds([]);
    fetchRequest({ page: 1, size: newRowsPerPage });
  };


  const onStatusChange = () => {
    setTableConfig(prev => ({ ...prev, currentPage: 1 }));
    setExpandedRow(null);
    setBulkSelectedIds([]);
  }

  const onHbrChange = useCallback((e) => {
    onStatusChange();
    setApproveStatus(e.target.value);
    if (notificationId) {
      setNotificationId(null);
      window.location.hash = '#request/';
    }
  }, [notificationId]);

  const selectRef = useRef();
  const siteSelectRef = useRef();

  useEffect(() => {
    const select = selectRef.current;
    if (!select) {
      return false; 
    }
    select.addEventListener('hbr-change', onHbrChange);
    return () => {
      select.removeEventListener('hbr-change', onHbrChange);
    };
   
  });

  const onSiteHbrChange = useCallback((e) => {
    const newSite = e.target.value ?? e.detail?.value ?? e.detail ?? '';
    setTableConfig(prev => ({ ...prev, currentPage: 1 }));
    setSelectedSite(newSite);
    setExpandedRow(null);
    setBulkSelectedIds([]);
    if (notificationId) {
      setNotificationId(null);
      window.location.hash = '#request/';
    }
  }, [notificationId]);

  useEffect(() => {
    const select = siteSelectRef.current;
    if (!select) return;
    select.addEventListener('hbr-change', onSiteHbrChange);
    return () => {
      select.removeEventListener('hbr-change', onSiteHbrChange);
    };
  });

  const groupedRequests = useMemo(() => {
    const groups = {};
    requestResponse.forEach(request => {
      const key = request.apiName;
      if (!groups[key]) {
        groups[key] = {
          apiName: request.apiName,
          apiGroup: request.apiDetails?.subdomainName || '',
          requests: [],
          pendingCount: 0
        };
      }
      groups[key].requests.push(request);
      if (request.status.toLowerCase() === 'pending') {
        groups[key].pendingCount++;
      }
    });
    const allGroups = Object.values(groups);
    allGroups.sort((a, b) => {
      if (b.pendingCount !== a.pendingCount) {
        return b.pendingCount - a.pendingCount;
      }
      const col = sortColumn || 'apiName';
      return a[col].localeCompare(b[col]);
    });
    return allGroups;
  }, [requestResponse, sortColumn]);

  useEffect(() => {
    if (searchTriggeredRef.current && searchTxt && groupedRequests.length > 0) {
      searchTriggeredRef.current = false;
      const idx = groupedRequests.findIndex(group =>
        group.requests.some(req =>
          req.applicationName?.toLowerCase().includes(searchTxt.toLowerCase())
        )
      );
      if (idx !== -1) {
        setExpandedRow(idx);
      }
    }
  }, [groupedRequests, searchTxt]);

  const handleSort = (column) => {
    setSortColumn(prev => prev === column ? null : column);
    setExpandedRow(null);
  };

  return (
    <div id="pubhub-widgets" className="pubhub-site-container">
    {isModalOpen && 
      <ActionModals
        show={isModalOpen}
        type={selectedRequest?.type}
        requestData={requestResponse.find(r => r.id === selectedRequest?.id)}
        slaTiers={editTierData.slaTiers}
        isTierChange={selectedRequest?.isTierChange}
        onClose={() => closeModal()}
        onSubmit={(data) => handleRequest(data)}
      />
    }
    <div className="mt-4 mx-5 request-table myaccess-table">
      <h4 className='text-primary mb-4'>API Access Request Management</h4>
      <div className='d-flex justify-content-between align-items-center'>
        <div className='d-flex align-items-center'>
          <span className='me-3'>Filter by Site:</span>
          <span className='select-box-width'>
              <hbr-select ref={siteSelectRef} value={selectedSite || ''} disabled={siteOptions.length === 0 ? true : undefined}>
                {siteOptions.length === 0 ? (
                  <hbr-option value="" disabled>No sites found</hbr-option>
                ) : (
                  siteOptions.map(site => (
                    <hbr-option key={site} value={site}>{site}</hbr-option>
                  ))
                )}
              </hbr-select>
          </span>
        <span className='me-3 ms-5'>Filter by Status:</span>
        <span className='select-box-width'>
        <hbr-select ref={selectRef}>
            <hbr-option value="">All</hbr-option>
              <hbr-option value="Pending">Pending</hbr-option>
              <hbr-option value="Approved">Approved</hbr-option>
              <hbr-option value="Denied">Denied</hbr-option>
              <hbr-option value="Invalid">Invalid</hbr-option>

        </hbr-select>
          </span>
        </div>
        <div className='d-flex align-items-center'>
          <div className="myaccess-search-container">
            <input
              type="text"
              className='search-inp'
              value={searchTxt}
              onChange={handleSearchTermChange}
              onKeyUp={handleKeyPress}
              placeholder="Search your Applications by Name"
            />
            <span onClick={handleSearch} className="search-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
              </svg>
            </span>
          </div>
          {notificationId && (
            <div className="ms-5">
              <hbr-button variant="outline" onClick={handleViewAll}>View all Requests</hbr-button>
            </div>
          )}
        </div>
      </div>
      <div className="table-wrapper">
      <table className="table mt-4 iap-table">
        <thead>
          <tr>
            <th className='arrow-head'></th>
            <th className={`api-name sortable-header${sortColumn === 'apiName' ? ' sorted' : ''}`} onClick={() => handleSort('apiName')}>
              API Name
              <i className="bi bi-arrow-down sort-arrow"></i>
            </th>
            <th className={`api-group sortable-header${sortColumn === 'apiGroup' ? ' sorted' : ''}`} onClick={() => handleSort('apiGroup')}>
              API Group
              <i className="bi bi-arrow-down sort-arrow"></i>
            </th>
            <th className='status-col'>Actionable Items</th>
            <th className='bulk-action-col'></th>
          </tr>
        </thead>
        <tbody >
          {groupedRequests.length > 0 && groupedRequests.map((group, ind) => (
            <React.Fragment key={group.apiName}>
              <tr onClick={() => toggleRow(ind)} style={{ cursor: 'pointer' }}>
                <td className='arrow-head'> 
                  <IconChevron isopen={expandedRow === ind} />
                </td>
                <td className='api-name'><strong>{group.apiName}</strong></td>
                <td className='api-group'>{group.apiGroup}</td>
                <td className='status-col'>
                  {group.pendingCount > 0 && (
                    <hbr-tag
                      class="text-center"
                      sentiment="warning"
                      size="medium"
                    >
                      {group.pendingCount} Pending Requests
                    </hbr-tag>
                  )}
                </td>
                <td className='bulk-action-col' onClick={(e) => e.stopPropagation()}>
                  {expandedRow === ind && bulkSelectedIds.length > 0 && (
                    <div className="bulk-action-bar">
                      <span className="bulk-label">Selected</span>
                      <span className="bulk-count">{bulkSelectedIds.length}</span>
                      <button className="bulk-approve-btn" onClick={handleBulkApprove}>
                        <i className="bi bi-check2"></i> Approve
                      </button>
                      <button className="bulk-deny-btn" onClick={handleBulkDeny}>
                        <i className="bi bi-x"></i> Deny
                      </button>
                    </div>
                  )}
                </td>
              </tr>
              {expandedRow === ind && (
                <tr>
                  <td colSpan="5" className="expand_row-td p-0">
                    <ApplicationDetails
                      requests={group.requests}
                      onAction={(type, id, gateway, isTierChange) => clickPop(type, id, gateway, isTierChange)}
                      onSelectionChange={(ids) => setBulkSelectedIds(ids)}
                    />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
          {groupedRequests.length === 0 && (
           <tr>
            <td colSpan="5">
                  <div className='text-center empty-state'>
                    <img
                                src="https://www.cisco.com/c/dam/cdc/ui/atm/1-5-0/images/illustrations/empty-state/no-results-light-large.svg"
                                alt="Empty state illustration"
                                width="240px"
                                height="160px"
                            />
                    <p className='text-center mb-0'>No Records found</p>
                  </div>
            </td>
           </tr>
          )}
        </tbody>
      </table>
      </div>
      { tableConfig.totalPages > 0 &&
      <TablePaginationNew
          tableConfig={{
            currentPage: tableConfig.currentPage,
            totalPages: tableConfig.totalPages,
            rowsPerPage: tableConfig.pageSize,
            pageLimit: tableConfig.pageLimit
          }}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
      />}
    </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
      loader: state.access.isLoading,
      errorResponse: state.access.errorResponse,
      accessRequestList: state.access.accessRequestList,
      pendingRequestList: state.access.pendingRequestList,
      response: state.access.response,
      siteList: state.access.siteList
  }
}


export default connect(mapStateToProps)(MyAccessPage);

